﻿import { defineComponent } from 'vue';
import { Booking } from "../../services/booking";
import Banner from '../base/common/banner.vue'

export default defineComponent({
    components: {
        Banner
    },
    data() {
        return {
            isActive: false,
            isActive_Agency: false,
            mobileMenuOpen: false,
        }
    },
    methods: {
        show_welcome_banner(): boolean {
            return import.meta.env.VITE_SHOW_WELCOME_BANNER === 'true';
        },
        cart_count(): number {

            if ((this.$store.getters.get_Basket.trips.length == 1) && (this.$store.getters.get_Basket.trips[0].tour_id == "")) {
                return 0;
            }

            const Book = new Booking();
            return this.$store.getters.get_Basket.trips.length + Book.getTotal_Add_Ons(this.$store.getters.get_Basket);

        },
        cart_has_items(): boolean {
            return this.cart_count() > 0;
        },
        get_Logo(): string {
            return String(import.meta.env.VITE_DEFAULT_LOGO);
        },
        Has_second_logo(): boolean {
            return import.meta.env.VITE_DEFAULT_LOGO_TWO != undefined;
        },
        get_Logo_Two(): string {
            return String(import.meta.env.VITE_DEFAULT_LOGO_TWO);
        },
        get_phone_number(): string {
            return String(import.meta.env.VITE_DEFAULT_PHONE_NUMBER);
        },
        get_phone_reference(): string {
            let phone = String(import.meta.env.VITE_DEFAULT_PHONE_NUMBER);
            return "tel:" + phone.replace(/[^0-9]/g, "");
        },
        show_nav_link(): boolean {
            return import.meta.env.VITE_SHOW_NAVBAR_LINKS === 'true';
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isConsumer_Login(): boolean {
            return import.meta.env.VITE_AGENT_IDENTITY_URL == undefined;
        },
        Go_Home() {
            this.$router.push('/')
        },
        My_Profile() {
            this.$router.push('/my_profile')
        },
        Manage_Bookings() {
            this.$router.push('/manage_bookings')
        },
        Log_Out() {
            this.$store.commit("Logout_Agent");
            this.$router.push('/login');
        },
        Cart() {
            this.$router.push('/cart');
        },
        Logo_Click() {
            if(import.meta.env.VITE_BASE_SITE_URL != undefined && import.meta.env.VITE_BASE_SITE_URL != "")
            {
                window.location.href = import.meta.env.VITE_BASE_SITE_URL;
            }
            else
            {
                this.$router.push('/');
            }
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    },
    mounted() {
    }
})